import { render } from "./CookiesIcon.vue?vue&type=template&id=3630f63b"
import script from "./CookiesIcon.vue?vue&type=script&lang=js"
export * from "./CookiesIcon.vue?vue&type=script&lang=js"

import "./CookiesIcon.vue?vue&type=style&index=0&id=3630f63b&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__